import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppContext } from "../AppContext";
import { getPathForLanguage, getLangFromPath, ES_HOME_PATH, EN_HOME_PATH } from "../routes";

const STORAGE_KEY = "site_lang";

/**
 * Visible EN / Español toggle — no Google Translate.
 * Switches to the matching page URL when one exists; otherwise goes to the home page in that language.
 */
export default function LanguageSwitcher({ className = "" }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { setSiteLang } = useAppContext();
  const currentLang = getLangFromPath(location.pathname);

  useEffect(() => {
    setSiteLang(currentLang);
    localStorage.setItem(STORAGE_KEY, currentLang);
  }, [currentLang, setSiteLang]);

  const switchTo = (lang) => {
    if (lang === currentLang) return;
    localStorage.setItem(STORAGE_KEY, lang);
    setSiteLang(lang);
    const pathForLang = getPathForLanguage(location.pathname, lang);
    if (pathForLang !== null) {
      navigate(pathForLang);
    } else {
      navigate(lang === "es" ? ES_HOME_PATH : EN_HOME_PATH);
    }
  };

  const baseBtn =
    "px-4 py-2 text-sm font-bold transition-colors cursor-pointer border-2 border-[#26A94A]";
  const activeBtn = "bg-[#26A94A] text-white";
  const inactiveBtn = "bg-white text-[#1465B7] hover:bg-[#E4F7F9]";

  return (
    <div
      className={`inline-flex rounded-full overflow-hidden shadow-md ring-1 ring-black/5 ${className}`}
      role="group"
      aria-label="Seleccionar idioma / Select language"
    >
      <button
        type="button"
        onClick={() => switchTo("en")}
        className={`${baseBtn} rounded-l-full ${currentLang === "en" ? activeBtn : inactiveBtn}`}
        aria-pressed={currentLang === "en"}
      >
        English
      </button>
      <button
        type="button"
        onClick={() => switchTo("es")}
        className={`${baseBtn} rounded-r-full border-l-0 ${currentLang === "es" ? activeBtn : inactiveBtn}`}
        aria-pressed={currentLang === "es"}
      >
        Español
      </button>
    </div>
  );
}
